import { render, staticRenderFns } from "./ComplexenView.vue?vue&type=template&id=02085ea2"
import script from "./ComplexenView.vue?vue&type=script&lang=js"
export * from "./ComplexenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports